/**
 * @fileoverview - Adds or updates package protection in cart.
 * Note: Does not support multiple currencies, only works well with
 * USD.
 */

/**
 * Adds free productY to cart if productX is in cart.
 * Note: Logic is currently set to add 1 free nail glue for every C-curve
 * product type purchase.
 */
function buyXgetY() {
  return new Promise(async (resolve, reject) => {
    // Get cart items from current cart.
    var cartContents = await fetch(window.theme.localeRootUrl + '/cart.js')
      .then((response) => response.json())
      .then((data) => {
        return data;
      });

    var cCurvesInCart = 0,
      glueInCart = 0;
    for (var item of cartContents.items) {
      // Check if a C-curve exists in cart.
      if (
        item.product_type === 'C-Curve' &&
        !Object.keys(item.properties).length
      ) {
        cCurvesInCart += item.quantity;
      }

      // Check if glue is already in cart.
      if (item.id === 39986663719048 && !Object.keys(item.properties).length) {
        glueInCart += item.quantity;
      }
    }

    var glueToAdd = cCurvesInCart - glueInCart;
    if (glueToAdd <= 0) {
      resolve();
    } else {
      await fetch(window.theme.localeRootUrl + '/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: [
            {
              id: 39986663719048, // Nail glue variant id.
              quantity: glueToAdd,
            },
          ],
        }),
      }).then(function (response) {
        if (response.ok) {
          resolve();
        } else {
          reject(`Failed to add free glue`);
        }
      });
    }
  });
}

/**
 * Adds or updates package protection in cart. Goes through the cart and check
 * if adding or updating pacakge protection is needed. Package protection and
 * insurance are the same.
 * @returns {Promise} - Promise object that represents whether checking the
 *   insurance was successful.
 */
async function insuranceChecker() {
  return new Promise(async (resolve, reject) => {
    // Note: You can add a condition to enable buyXgetY logic here, but would
    // need to change the logic from the function to enable it to work for
    // what you want.
    // await buyXgetY();

    // Product ids of package protection variants.
    var firstVariant = 39553534853256,
      secondVariant = 39553534886024,
      thirdVariant = 39553534918792,
      fourthVariant = 39553534951560,
      fifthVariant = 39553534984328,
      sixthVariant = 39553535017096;

    var insuranceInCartId = 0;
    var insuranceInCart = false;
    var insuranceInCartKey = '';

    // Get cart items from current cart.
    var cartContents = await fetch(window.theme.localeRootUrl + '/cart.js')
      .then((response) => response.json())
      .then((data) => {
        return data;
      });

    var cartTotal = cartContents.total_price;

    // Search if package protection in cart.
    for (var item of cartContents.items) {
      if (item.handle == 'kiara-sky-package-protection') {
        insuranceInCart = true;
        insuranceInCartId = item.id;
        insuranceInCartKey = item.key;

        // Remove price of package protection from total cart price.
        cartTotal -= item.price;
      }
    }

    if (!insuranceInCart) {
      // Resolve when user already have removed insurance/package protection
      // during session.
      if (sessionStorage.getItem('removed_insurance')) {
        resolve();
      } else {
        if (cartTotal <= 14998 && cartTotal >= 1) {
          addInsurance(firstVariant);
        } else if (cartTotal >= 14999 && cartTotal <= 24998) {
          addInsurance(secondVariant);
        } else if (cartTotal >= 24999 && cartTotal <= 34998) {
          addInsurance(thirdVariant);
        } else if (cartTotal >= 34999 && cartTotal <= 44998) {
          addInsurance(fourthVariant);
        } else if (cartTotal >= 44999 && cartTotal <= 60100) {
          addInsurance(fifthVariant);
        } else if (cartTotal >= 60101) {
          addInsurance(sixthVariant);
        } else {
          resolve();
        }
      }
    } else {
      if (
        cartTotal >= 14999 &&
        cartTotal <= 24998 &&
        insuranceInCartId != secondVariant
      ) {
        updateInsurance(insuranceInCartKey, secondVariant);
      } else if (
        cartTotal >= 24999 &&
        cartTotal <= 34998 &&
        insuranceInCartId != thirdVariant
      ) {
        updateInsurance(insuranceInCartKey, thirdVariant);
      } else if (
        cartTotal >= 34999 &&
        cartTotal <= 44998 &&
        insuranceInCartId != fourthVariant
      ) {
        updateInsurance(insuranceInCartKey, fourthVariant);
      } else if (
        cartTotal >= 44999 &&
        cartTotal <= 60100 &&
        insuranceInCartId != fifthVariant
      ) {
        updateInsurance(insuranceInCartKey, fifthVariant);
      } else if (cartTotal >= 60101 && insuranceInCartId != sixthVariant) {
        updateInsurance(insuranceInCartKey, sixthVariant);
      } else if (
        cartTotal <= 14998 &&
        cartTotal >= 1 &&
        insuranceInCartId != firstVariant
      ) {
        updateInsurance(insuranceInCartKey, firstVariant);
      } else if (cartTotal == 0) {
        updateInsurance(insuranceInCartKey);
      } else {
        resolve();
      }
    }

    /**
     * Adds package protection in cart.
     * @param {number} id - Product id of the package protection to be added in
     *   cart.
     */
    async function addInsurance(id) {
      await fetch(window.theme.localeRootUrl + '/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: [
            {
              id: id,
              quantity: 1,
            },
          ],
        }),
      }).then(function (response) {
        if (response.ok) {
          resolve();
        } else {
          reject(`Failed to add insurance with id: ${id}`);
        }
      });
    }

    /**
     * Updates package protection that is already in cart.
     * @param {string} toRemove - Product key of package protection in cart.
     * @param {number} toAdd -  Product id of the new package protection to
     *   replace removed package protection.
     */
    async function updateInsurance(toRemove, toAdd = 0) {
      await fetch(window.theme.localeRootUrl + '/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({
          id: toRemove,
          quantity: 0,
        }),
      }).then(async function (response) {
        if (response.ok) {
          if (toAdd !== 0) {
            await addInsurance(toAdd);
          }
          resolve();
        } else {
          reject(`Failed to remove insurance with key: ${toRemove}`);
        }
      });
    }
  });
}
